<div *ngIf="landingPageFlag">
  <app-landing-page></app-landing-page>
</div>